export default __webpack_public_path__ + "static/media/210.c152404b.jpg";